import { z } from 'zod';
export const isBotPathSchema = z.object({
    identityId: z.string(),
});
export const isBotInputSchema = isBotPathSchema;
export const isBotOutputSchema = z.object({
    score: z.number(),
});
